import {
    getData,
    postData,
    patchData,
    deleteData
} from './Services'

export const getProvinciasLista = async () => {
    const res = await getData('/provincias/provincias_select');
    return res
}

export const getProvinciasPanel = async (searchTerm, page, perPage) => {
    let queryParams = [];
    if (searchTerm) {
        queryParams.push(`pcia_descripcion=${encodeURIComponent(searchTerm || '')}`);
    }
    if (page) {
        queryParams.push(`page=${encodeURIComponent(page || 1)}`);
    }
    if (perPage) {
        queryParams.push(`perPage=${encodeURIComponent(perPage || 10)}`);
    }
    const queryString = queryParams.length > 0 ? `?&${queryParams.join('&')}` : '';
    return await getData("/provincias", queryString);
};

export const getProvinciaById = async (id) => {
    const res = await getData(`/provincias/${id}`)
    return res
}

export const getXProvincia = async (searchTerm) => {
    return await getData("/provincias", `?pcia_descripcion=${searchTerm}`);
};

export const postProvincia = async (body) => {
    const res = await postData('/provincias', body)
    return res
}

export const patchProvincia = async (id, body) => {
    const res = await patchData(`/provincias/${id}`, body)
    return res
}

export const deleteProvincia = async (id) => {
    const res = await deleteData(`/provincias/${id}`)
    return res
}